import {DriveComment, DriveReply} from '../drive/types';
import {formatDisplayDate} from './naming';

/** Unresolved, non-deleted comment threads, oldest first (so the newest sits next to the composer). */
export function getOpenThreads(comments: DriveComment[] | undefined): DriveComment[] {
    return (comments ?? [])
        .filter((c) => !c.resolved && !c.deleted)
        .sort((a, b) => a.createdTime.localeCompare(b.createdTime));
}

/** Replies worth showing: not deleted, and not a bare resolve/reopen marker without text. */
export function getVisibleReplies(comment: DriveComment): DriveReply[] {
    return (comment.replies ?? []).filter((r) => !r.deleted && (!!r.content?.trim() || r.action === 'reopen'));
}

/** Drive returns protocol-relative avatar URLs ("//lh3.googleusercontent.com/…"). */
export function normalizePhotoLink(photoLink: string | undefined): string | undefined {
    if (!photoLink) return undefined;
    return photoLink.startsWith('//') ? `https:${photoLink}` : photoLink;
}

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** Short Hungarian relative timestamp ("épp most", "5 perce", "3 órája", "2 napja"), falling back to a date. */
export function formatRelativeTime(iso: string, now: Date = new Date()): string {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    const diff = now.getTime() - date.getTime();
    if (diff < MINUTE) return 'épp most';
    if (diff < HOUR) return `${Math.floor(diff / MINUTE)} perce`;
    if (diff < DAY) return `${Math.floor(diff / HOUR)} órája`;
    if (diff < 7 * DAY) return `${Math.floor(diff / DAY)} napja`;
    return formatDisplayDate(date);
}
